export default __webpack_public_path__ + "static/media/diffusion-banner.ebe54a4a.png";